export default "__VITE_ASSET__BHQbMm7D__"